import React from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider,Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {hasAuth,getLoginUser} from "../../../utils/NHCore";
import {NHModal, NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import ViewForm from './ViewForm.js';
import css from './index.css';


const confirm = Modal.confirm;

const baseUrlPath = "/ksdh";


class KsdhTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap:{
                tableFlag:true,
                addFlag:false,
                updateFlag:false,
                showFlag:false,
            },
            zt0:'',//状态名称
            zt1:'',//状态名称
            showDeleteBtn:false,//显示删除按钮
        };
    }

    //渲染前加载启用停用按钮参数
    componentDidMount() {
        NHFetch("/proData/selectDataList", "GET", {sign: 'dmk_xtgl_zt'})
            .then(resData => {
                if (resData.data != null) {
                    if(resData.data[0]!=null && resData.data[1]!=null && resData.data[0].VALUE=='1' && resData.data[1].VALUE=='0' ) {
                        this.setState({zt0:resData.data[1].LABEL,zt1:resData.data[0].LABEL});
                    }
                }
            })
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap=this.state.frameVisibleMap;
        for(let name in frameVisibleMap){
            if(name==showFlagName){
                frameVisibleMap[name]=true;
            }else{
                frameVisibleMap[name]=false;
            }
        }
        this.setState({
            frameVisibleMap:frameVisibleMap
        });
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    }
    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;
        NHFetch(baseUrlPath + '/' + pkid + '/get', 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('updateFlag');
                }
            })
    }
    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({formInitData:record});
        this.setCurrentPageShow('showFlag');
    }
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
       NHConfirm("是否确定删除这条数据？",() => {
           let pkid = record.PKID;
           this.handleDelete([pkid]);
       },"warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(baseUrlPath + '/deleteByMulti' , 'POST' , pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }
    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            NHFetch(baseUrlPath + '/insert' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success("新增快速导航成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    }
    //修改面板保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            formData.pkid = this.state.formInitData.pkid;
            NHFetch(baseUrlPath + '/update' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success("修改快速导航成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    }


    //单行启用禁用
    updateState = (record) => {
        let PKID = record.PKID;
        NHFetch(baseUrlPath+"/updateState","POST",{"pkid":PKID})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                }else{
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    }

    rowSelectionChange=(selectedRowKeys)=>{
        if (selectedRowKeys.length) {
            this.setState({
                showDeleteBtn:true,showSendBtn:true
            })
        } else {
            this.setState({
                showDeleteBtn:false,showSendBtn:false
            })
        }
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                width: '70',
                dataIndex: 'ROW_ID'
            }, {
                title: '链接名称',
                width: '200',
                dataIndex: 'LJMC',
                searchType:"input"
            }, {
                title: '链接地址',
                width: '250',
                dataIndex: 'LJDZ',
                searchType:"input"
            }, {
                title: '链接类型',
                width: '150',
                dataIndex: 'LJLXMC',
                render:(text,record,index) => {
                    return (
                       <span>{record.LJLXMC}</span>
                    );
                },
                searchType:"input"
            }, {
                title: '排序号',
                width: '80',
                dataIndex: 'PXH',
                searchType:"input"
            }, {
                title: '状态',
                width: '100',
                dataIndex: 'ZTMC',
                render:(text,record,index) => {
                    const status=record.ZT=='1'?true:false;
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_ksdh:updateState')?
                            <Switch checkedChildren={this.state.zt1} unCheckedChildren={this.state.zt0} checked={status} onChange={() => this.updateState(record)}/>:
                            <span>{status?this.state.zt1:this.state.zt0}</span>
                    );
                },
                searchType:"select"
            }
        ];
        //行内操作
        const action = [
            {title:'查看',onClick:this.handleViewBtnClick,auth:'zhxg_yxgl_fwwgl_ksdh:view'},
            {title:'修改',onClick:this.handleUpdateBtnClick,auth:'zhxg_yxgl_fwwgl_ksdh:udpate'},
            {title:'删除',onClick:this.handleSingleDeleteBtnClick,auth:'zhxg_yxgl_fwwgl_ksdh:multiple_delete'},

        ];
        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-163}}>
                <div className={css.table} style={{display:this.state.frameVisibleMap.tableFlag?'block':'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record =>record.PKID}
                             sign={"zhxg_yxxt_fwwgl_ksdh_queryPage"}
                             columns={columns}
                             action={action}
                             rowSelectionChange={this.rowSelectionChange}
                    >
                        {hasAuth('zhxg_yxgl_fwwgl_ksdh:add')?<Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>:null}
                        {hasAuth('zhxg_yxgl_fwwgl_ksdh:delete')?<Button type="danger" ghost style={{marginLeft:10,display:this.state.showDeleteBtn?undefined:'none'}}
                                                                        onClick={this.handleMultiDeleteBtnClick}>删除</Button>:null}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                         title="快速导航新增"
                         visible={this.state.frameVisibleMap.addFlag}
                         onOk={this.handleSaveAdd}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm" zt0={this.state.zt0} zt1={this.state.zt1} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                         title="修改快速导航"
                         visible={this.state.frameVisibleMap.updateFlag}
                         onOk={this.handleSaveUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm"  initFormData={this.state.formInitData} zt0={this.state.zt0} zt1={this.state.zt1}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                         visible={this.state.frameVisibleMap.showFlag}
                         title="查看快速导航"
                         onCancel={this.handleCloseFrame}
                         footer={[]}
                >
                    <ViewForm initFormData={this.state.formInitData} zt0={this.state.zt0} zt1={this.state.zt1} />
                </NHContainerFrame>
            </div>
        );
    }
}
export default KsdhTab;



// WEBPACK FOOTER //
// ./components/fwwgl/ksdh/KsdhTab.js